<template>
    <svg class="cnm-icon" width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M15 3.95703H19C19.5304 3.95703 20.0391 4.16774 20.4142 4.54282C20.7893 4.91789 21 5.4266 21 5.95703V19.957C21 20.4875 20.7893 20.9962 20.4142 21.3712C20.0391 21.7463 19.5304 21.957 19 21.957H15" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M10 17.957L15 12.957L10 7.95703" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M15 12.957H3" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
</template>
